import {API_MODULES, API_ROUTES, API_SOLUTIONS} from "@api/ApiRoutes";
import {generateApiEndpoint} from "@api/ApiUtils";
import {getRequest} from "@api/ApiService";
import {ModuleCms, WebappCms} from "@lib/Cms/CmsModels";

const ROUTES = {
    GET_CMS_WEBAPP: {
        path: API_ROUTES.GET_CMS_WEBAPP,
        module: API_MODULES.SOLUTION,
        solution: API_SOLUTIONS.MZ
    },
    GET_CMS_USER: {
        path: API_ROUTES.GET_CMS_USER,
        module: API_MODULES.CORE_USER,
        solution: API_SOLUTIONS.MZ
    },
    GET_CMS_CONTEST: {
        path: API_ROUTES.GET_CMS_CONTEST,
        module: API_MODULES.FORMAT_CONTEST,
        solution: API_SOLUTIONS.MZ
    },
    GET_CMS_EVENT: {
        path: API_ROUTES.GET_CMS_EVENT,
        module: API_MODULES.FORMAT_EVENT,
        solution: API_SOLUTIONS.MZ
    },
    GET_CMS_REWARD: {
        path: API_ROUTES.GET_CMS_REWARD,
        module: API_MODULES.CORE_REWARD,
        solution: API_SOLUTIONS.MZ
    }
}

class CmsService {

    static getWebapp = async (): Promise<WebappCms> => await getRequest<WebappCms>(generateApiEndpoint(ROUTES.GET_CMS_WEBAPP));

    static getUserCms = async (): Promise<ModuleCms> => await getRequest<ModuleCms>(generateApiEndpoint(ROUTES.GET_CMS_USER));

    static getRewardCms = async (): Promise<ModuleCms> => await getRequest<ModuleCms>(generateApiEndpoint(ROUTES.GET_CMS_REWARD));

    static getEventCms = async (): Promise<ModuleCms> => await getRequest<ModuleCms>(generateApiEndpoint(ROUTES.GET_CMS_EVENT));


}

export default CmsService;